// Models
import Model from './Model'

class PaymentFee extends Model {
  get isReturned () {
    return this.returned === true
  }

  get isReturn () {
    return this.return === true
  }

  get schema () {
    return [
      'accountId',
      'accountName',
      'accountType',
      'amount',
      'currency',
      'id',
      'paymentId',
      'return',
      'returned'
    ]
  }
}

export default PaymentFee
